<template>
  <b-modal :title="modal?.title"
           :modelValue="modal !== null"
           footer-class="border-top-0 d-flex justify-content-between"
           @update:modelValue="$event === false && (modal = null)">
    <template #default>
      <div class="row">
        <div class="col-sm-12">

          <div class="form-check" v-for="result in results">
            <input class="form-check-input" v-model="form.result" :value="result" type="radio" name="reason" :id="`result_${result}`">
            <label class="form-check-label" :for="`result_${result}`">
              {{ helper.trans(`dispute_result.${result}`) }}
            </label>
          </div>
        </div>
      </div>
    </template>
    <template #footer>
      <button type="button" @click="modal = null" class="btn btn-outline-dark btn-sm text-capitalize-first">
        {{ modal?.cancelTitle ?? helper.trans('button.cancel')  }}
      </button>
      <LoaderWrapper ref="loader" :zoom="0.5">
        <button type="button" @click="onOkClick()" class="btn btn-outline-danger btn-sm text-capitalize-first">
          {{ modal?.okTitle ?? helper.trans('button.ok') }}
        </button>
      </LoaderWrapper>

    </template>
  </b-modal>
</template>

<script lang="ts">

import {defineComponent, ref} from 'vue'
import {reactive, toRefs} from "@vue/reactivity";
import {BModal} from "bootstrap-vue-3";
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {helper} from "@/service/CommonHelper";
import {DisputeResult} from "@/models/enum/DisputeResult";

export interface DealConfirmModalProps {
  title: string;
  okTitle: string|null,
  cancelTitle: string|null,
  onOkClick(result: DisputeResult): void
}

export default defineComponent({
  components: {
    BModal,
    LoaderWrapper
  },
  setup() {
    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const result = Object.values(DisputeResult);

    const state = reactive({
      modal: null as DealConfirmModalProps|null,
      form: {
        result: DisputeResult.INVALID_PAYMENT_METHOD as DisputeResult,
      },
    });

    const show = (props: DealConfirmModalProps) => {
      state.modal = props
    }

    const onOkClick = async () => {
      if (!state.modal) {
        return;
      }

      loader.value?.show()
      try {
        await state.modal.onOkClick(state.form.result);
      } finally {
        loader.value?.hide()
      }

      state.modal = null;
    }

    const getForm = () => {
      return {
        disputeResult: state.form.result,
      };
    }

    const results = [
      DisputeResult.REQUISITES_MISMATCH_IN_CONFIRM_DOCS,
      DisputeResult.INVALID_PAYMENT_METHOD,
      DisputeResult.TTL_EXPIRED,
      DisputeResult.FRAUD_CONFIRM_DOCS,
      DisputeResult.WAITING_CONFIRM_DOCS_FROM_MERCHANT,
      DisputeResult.WAITING_CONFIRM_DOCS_FROM_TRADER,
      DisputeResult.UNKNOWN,
    ];

    return {
      ...toRefs(state),
      onOkClick,
      show,
      loader,
      helper,
      result,
      DisputeResult,
      getForm,
      results
    }
  }
})
</script>
